import { lookupStore } from '../stores';

/**
 * Each entry pairs a lookup fetcher with the ATS field tokens it supplies.
 *
 * `tokens: null` skips the required-field block check for that lookup.
 * This is used for customFields whose token names are company-specific
 * and cannot be known before the fetch succeeds.
 *
 * To add a new lookup: append a new entry here — no changes needed elsewhere.
 */
export const LOOKUP_CONFIGS = [
  {
    name: 'Custom Fields',
    call: (token, type) => lookupStore.getCustomFieldsPublic(token, type),
    tokens: null,
  },
  {
    name: 'Work Types',
    call: (token, type) => lookupStore.getCurrentWorkTypesPublic(token, type),
    tokens: ['ats-candidate_current_work_type', 'ats-current_work_type', 'ats-candidate_desired_work_type'],
  },
  {
    name: 'Countries',
    call: (token, type) => lookupStore.getCountriesPublic(token, type),
    tokens: ['ats-candidate_country', 'ats-country'],
  },
  {
    name: 'Candidate Statuses',
    call: (token, type) => lookupStore.getCandidateStatusesPublic(token, type),
    tokens: ['ats-candidate_status'],
  },
  {
    name: 'Client Statuses',
    call: (token, type) => lookupStore.getClientStatusesPublic(token, type),
    tokens: ['ats-contact_status'],
  },
  {
    name: 'Salutations',
    call: (token, type) => lookupStore.getSalutationsPublic(token, type),
    tokens: ['ats-candidate_salutation', 'ats-contact_salutation'],
  },
  {
    name: 'Skill Categories',
    call: (token, type) => lookupStore.getSkillCategoriesPublic(token, type),
    tokens: ['ats-candidate_skill_category'],
  },
  {
    name: 'Skill Sub-Categories',
    call: (token, type) => lookupStore.getSkillSubCategoriesPublic(token, type),
    tokens: ['ats-candidate_skill_subcategory'],
  },
  {
    name: 'Skills',
    call: (token, type) => lookupStore.getSkillsPublic(token, type),
    tokens: ['ats-candidate_skill'],
  },
  {
    name: 'Public Companies',
    call: (token, type) => lookupStore.getPublicCompanies(token, type),
    tokens: ['ats-candidate_current_employer', 'ats-current_employer', 'ats-contact_organization'],
  },
];

/**
 * Returns true if the Tripetto definition contains a slot with `required: true`
 * whose serialized JSON includes at least one of the given ATS tokens.
 */
export const hasRequiredFieldFor = (definition, tokens) => {
  if (!tokens || !definition) return false;
  const check = (obj) => {
    if (!obj || typeof obj !== 'object') return false;
    if (Array.isArray(obj)) return obj.some(check);
    if (obj.required === true) {
      const json = JSON.stringify(obj);
      return tokens.some(t => json.includes(t));
    }
    return Object.values(obj).some(check);
  };
  return check(definition);
};
